import { googleMapsQueryKeys as e } from "./useGoogleMapsQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { googleMapsApi as n } from "@maat/api-base";
//#region src/googleMaps/useSearchPlacesQuery.ts
var r = (r) => t({
	queryKey: e.search(r),
	queryFn: () => n.searchPlaces(r),
	enabled: !!r
});
//#endregion
export { r as useSearchPlacesQuery };
